export default {
  SettingRuleTitle: 'QOS策略由流量分类规则和限速规则组成。系统通过流量分类规则，划分流量。系统将根据策略优先级关联的限速配置进行调配，优先保证关联高优先级限速规则的流量带宽。相同网关下，策略的流量分类信息不能重叠，以免影响策略生效，请知悉。',
  RelationNetTitle1: '您需要将QoS策略关联到目标网关实例上。关联后，网关实例通过匹配规则过滤流量。未关联网关则规则不会生效。若您的网关关联多条规则，您可在',
  RelationNetTitle2: 'QoS策略-已关联网关',
  RelationNetTitle3: '下，进行优先级设置。', // title1,2,3本为一句话，由于title2是可点击链接，所以拆开
  PlotName: '策略名称',
  PlotNameMsg: '请填写策略名称',
  SpeedLimitRule: '默认限速配置',
  MinBandwidth: '最小带宽',
  MinBandwidthMsg: '请填写最小带宽',
  MaxBandwidth: '最大带宽',
  MaxBandwidthMsg: '请填写最大带宽',
  MaxBandwidthExamp: '请自行确认绑定网关设备的采购带宽是否满足当前设置，以免影响策略生效',
  SettingQOS: '设置策略',
  QosCreatePriority: '默认优先级为当前策略的初始配置，修改只针对新关联网关生效。若您需要针对不同网关设置不同优先级，请前往',
  AllQosEffect: '，对全部策略生效', // 因为中间穿插可点击链接,所以拆分,原句:默认限速规则为全局配置，您的所有策略共用该限速配置。修改限速带宽将同步至限速配置，对全部策略生效。
  QosNameRepeat: '策略名称重复',
  SrcIpPH: '请填写流量数据包中的源地址，支持单一IP地址或者CIDR网段格式，放空视为不限',
  SrcPortPH: '请填写流量数据包中的源端口，取值范围从1到65535，放空视为不限',
  DestIpPH: '请填写流量数据包中的目标地址，支持单一IP地址或者CIDR网段格式，放空视为不限',
  DestPortPH: '请填写流量数据包中的目标端口，取值范围从1到65535，放空视为不限',
  PleaseSelectPriority: '请选择优先级',
  BandwidthFormat: '请输入合法带宽',
  BandwidthSizeTest: '最大带宽不能小于最小带宽',
  ChangeUser: '修改人',
  RecentChangeTime: '最近修改时间',
  LimitRuleAlert: '以下限速规则为全局配置，您创建的所有策略都将共用该限速配置。根据限速规则优先级，优先保证关联高优先级限速规则的流量带宽。',
  Effecting: '生效中',
  NoSetting: '未设置',
  SettingSuccess: '设置成功',
  EnableFail: '启用失败',
  RelatedLimitRule: '关联限速规则',
  LimitRuleSpecial: '特别提醒：您的所有策略共用该配置。修改限速带宽将同步至',
  Change: '修改'
}